import React from "react";
import { DateTime } from "luxon";
/**
 * One property of the member type, as a field of Mine oplysninger. What the property is (its label,
 * its hint, which editor) comes from the server; this only draws it.
 */
export default class MemberProfilePropertyComponent extends React.Component {
    constructor(props) {
        super(props);
        this.validationRegExp = (this.props.property.validation && this.props.property.validation !== '') ? new RegExp(this.props.property.validation) : new RegExp('.*');
        this.state = {
            property: this.props.property,
            dirty: false,
            value: this.props.property.value,
            valid: true
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(evt) {
        let dirty = evt.target.value !== this.props.property.value;
        let valid = evt.target.validity.valid;
        const propValue = this._valueFromEvent(evt);
        this.setState({ dirty: dirty, value: propValue, valid: valid }, () => {
            this.props.onDirty(this.props.property.alias, this.state.value, dirty);
        });
    }
    _valueFromEvent(evt) {
        switch (this.props.property.editorType) {
            case "Umbraco.TrueFalse":
                return evt.target.checked ? "1" : "0";
            default:
                return evt.target.value;
        }
    }
    hint() {
        const description = this.props.property.description;
        return (description && description !== '') ? React.createElement("div", { className: "bi-pf-hint" }, description) : React.createElement(React.Fragment, null);
    }
    textBox() {
        let validation = {
            pattern: (this.props.property.validation) ? this.props.property.validation : undefined,
            required: (this.props.property.mandatory) ? true : undefined
        };
        let classes = `bi-pf-input${this.state.dirty ? ' dirty' : ''}${this.state.valid ? '' : ' is-invalid'}`;
        if (this.props.property.editable) {
            return (React.createElement("div", { className: "bi-pf-field" },
                React.createElement("label", { className: "bi-pf-label", htmlFor: this.props.property.alias }, this.props.property.label),
                React.createElement("input", Object.assign({ type: "text", className: classes, id: this.props.property.alias, value: this.state.value, onChange: this.handleChange }, validation)),
                this.hint()));
        }
        else {
            return this.label(this.props.property.value);
        }
    }
    // A property the member can read but not change: the value as text. Nothing to read, nothing drawn.
    label(value) {
        if (!value)
            return null;
        return (React.createElement("div", { className: "bi-pf-field" },
            React.createElement("span", { className: "bi-pf-label" }, this.props.property.label),
            React.createElement("span", { className: "bi-pf-static" }, value),
            this.hint()));
    }
    trueFalse() {
        return (React.createElement("div", null,
            React.createElement("label", { className: "bi-pf-check", htmlFor: this.props.property.alias },
                React.createElement("input", { type: "checkbox", id: this.props.property.alias, checked: this.state.value === "1", onChange: this.handleChange }),
                this.props.property.label),
            this.hint()));
    }
    editor() {
        switch (this.props.property.editorType) {
            case "Umbraco.TextBox":
                return this.textBox();
            case "Umbraco.Label":
                return this.label(this.props.property.value);
            case "Umbraco.TrueFalse":
                return this.trueFalse();
            case "Umbraco.DateTime": {
                const date = DateTime.fromISO(this.props.property.value);
                return this.label(date.isValid ? date.toFormat('dd-MM-yyyy') : '');
            }
            default:
                return (React.createElement(React.Fragment, null,
                    React.createElement("label", { htmlFor: this.props.property.alias }, this.props.property.label),
                    React.createElement("div", null, this.props.property.editorType)));
        }
    }
    render() {
        return this.editor();
    }
}
